import { render, staticRenderFns } from "./CourseInstructors.vue?vue&type=template&id=66556915&scoped=true"
import script from "./CourseInstructors.vue?vue&type=script&lang=js"
export * from "./CourseInstructors.vue?vue&type=script&lang=js"
import style0 from "./CourseInstructors.vue?vue&type=style&index=0&id=66556915&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66556915",
  null
  
)

export default component.exports